<template>
  <div
    id="gift-card-popup"
    style="z-index:5"
    class="pos-fixed"
    @click.stop.prevent
  >
    <div
      class="overlay"
      style="background: rgba(0, 0, 0, 0.55);"
      v-if="isShowLeaderboardModal"
    >
      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
          color: '#000000'
        }"
        class=" padding-10 pos-fixed pos-center-ver pos-center-hor index-3 radius-3"
        style="width: 70%;
                max-height: 18rem;
                padding: 1.25rem;
                text-align: center;
                z-index: 1000;
                overflow: scroll;
                overflow-wrap: break-word;
                scrollbar-width: none;"
        v-if="isShowLeaderboardModal"
      >
        <div
          :style="{
            backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
            color: '#000000'
          }"
          class="myheader"
          style="padding-bottom: 0px;"
        >
          <div
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
            }"
            style="width: 100%; text-align: center;display: flex; justify-content: space-between;padding-top: 2px; align-items: center;"
          >
            <span
              style="font-size: 18px; font-weight: 600; color: #323232;"
              @click.stop.prevent
              >Rules</span
            >
            <span
              @click.stop="toggleLeaderboardModal(false, model)"
              style="cursor: pointer;padding-right: 10px; color: gray !important;"
            >
              <close-icon :isPopUp="true" />
            </span>
          </div>

          <hr
            style="margin-left: -7px;
    width: 100%;"
          />
        </div>

        <div style="white-space: normal;display: flex; margin-top: 30px; ">
          <p
            style="overflow: scroll; text-align: left; margin-top: 2px; scrollbar-width: none; color: #3C3C3E;"
            v-html="cleanedRules"
          ></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import CloseIcon from "@/components/close-icon.vue";
export default {
  mixins: [globals],
  props: {
    model: Object
  },
  components: {
    CloseIcon
  },
  data() {
    return {
      receiverName: "",
      receiverEmail: "",
      refNum: ""
    };
  },
  computed: {
    cleanedRules() {
      return this.model.rules.replace(/color\s*:\s*[^;"]+;?/gi, "");
    },
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    }
  },
  methods: {
    showContactNumber(name) {
      return name.toLowerCase().includes("paytm");
    }
  },
  created() {
    var trans = this.model;
  }
};
</script>
<style>
.myheader {
  -moz-osx-font-smoothing: grayscale;
  position: fixed;
  width: inherit;
  background-color: white;
  margin-top: -17px;
  padding: 7px;
  height: 30px;
}
</style>
